import type { PropsWithChildren } from 'react';
import { I18nextProvider } from 'react-i18next';

import { AuthProvider, type AuthProviderProps } from '../auth/AuthProvider';
import { CapabilityProvider, type CapabilityId, type DataSource } from '../config/capabilities';
import i18n from '../i18n';
import { ThemeProvider } from '../theme/ThemeProvider';

export type AppProvidersProps = PropsWithChildren<
  Omit<AuthProviderProps, 'children'> & {
    readonly capabilities?: Partial<Readonly<Record<CapabilityId, DataSource>>>;
  }
>;

export function AppProviders({ capabilities, children, ...authProviderProps }: AppProvidersProps) {
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider>
        <AuthProvider {...authProviderProps}>
          <CapabilityProvider overrides={capabilities ?? {}}>{children}</CapabilityProvider>
        </AuthProvider>
      </ThemeProvider>
    </I18nextProvider>
  );
}
